import { Navigate, Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import {
  COHORT_BUILDER_PATH,
  COHORT_VERSION_PATH,
  DATA_RELIABILITY_PATH,
} from '@verantos-dev/core-constants';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { CohortBuilderPage, CohortVersionLoadingPage } from '@verantos-dev/feature-cohort-builder';
import { CohortListPage } from '@verantos-dev/feature-cohort-list';
import { DataReliabilityPage } from '@verantos-dev/feature-data-reliability';
import { ProjectsListPage } from '@verantos-dev/feature-projects-list';

const APP_ID = EvidencePlatformSidebarAppID.projects;

export const ProjectsUiRoutes = () => {
  useAppId(APP_ID);

  return (
    <Routes>
      <Route index element={<ProjectsListPage />} />
      <Route path=":projectId">
        <Route path="cohorts">
          <Route index element={<CohortListPage />} />
          <Route path=":cohortId">
            <Route index element={<CohortVersionLoadingPage />} />
            <Route path={COHORT_VERSION_PATH}>
              <Route index element={<CohortVersionLoadingPage />} />
              <Route path=":cohortVersionId">
                <Route index element={<Navigate to={COHORT_BUILDER_PATH} />} />
                <Route path={COHORT_BUILDER_PATH}>
                  <Route index element={<CohortBuilderPage />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path={DATA_RELIABILITY_PATH} element={<DataReliabilityPage />} />
      </Route>
    </Routes>
  );
};

export default withAuth(ProjectsUiRoutes, APP_ID);
